import { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import { Shield, Scale } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ICONS = { confidentialite: Shield, "mentions-legales": Scale };

export default function DynamicPage() {
  const { slug: paramSlug } = useParams();
  const location = useLocation();
  const slug = paramSlug || location.pathname.replace("/", "");
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/pages/${slug}`)
      .then((r) => setPage(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center pt-24">
        <div className="w-8 h-8 border-2 border-blue-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!page) {
    return (
      <div className="min-h-screen flex items-center justify-center pt-24">
        <p className="font-body text-slate-400">Page non trouv{"\u00e9"}e</p>
      </div>
    );
  }

  const IconComp = ICONS[slug] || Shield;

  return (
    <div data-testid={`page-${slug}`} className="pt-24">
      <section className="py-24 md:py-32">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <div className="flex items-center gap-3 mb-6">
            <IconComp className="w-6 h-6 text-blue-400" />
            <p className="font-body text-xs md:text-sm font-medium tracking-[0.2em] uppercase text-blue-400">
              {page.subtitle}
            </p>
          </div>
          <h1 className="font-heading text-4xl sm:text-5xl font-light tracking-tight text-slate-50 mb-12 leading-[1.1]">
            {page.title}
          </h1>

          <div className="space-y-10">
            {(page.sections || []).map((section, i) => (
              <div key={i}>
                <h2 className="font-heading text-2xl text-slate-50 mb-4">{section.heading}</h2>
                <div className="font-body text-base text-slate-300 leading-relaxed whitespace-pre-line">
                  {section.body}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
